import { request } from '@/api/index';
export function getList(params) {
  return request({
    url: '/api/Dictionary/TableDatas',
    method: 'get',
    params: params
  });
}
export function getInfo(params) {
  return request({
    url: '/api/Dictionary/GetInfo',
    method: 'get',
    params: params
  });
}
export function modifySort(data) {
  return request({
    url: '/api/Dictionary/ModifySort',
    method: 'post',
    data: data
  });
}
export function createData(data) {
  return request({
    url: '/api/Dictionary/Add',
    method: 'post',
    data: data
  });
}
export function updateData(data) {
  return request({
    url: '/api/Dictionary/Edit',
    method: 'post',
    data: data
  });
}